import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1);
const _hoisted_2 = { class: "fixed z-10 inset-0 overflow-y-auto" };
const _hoisted_3 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", {
    class: "hidden sm:inline-block sm:align-middle sm:h-screen",
    "aria-hidden": "true"
}, "​", -1);
const _hoisted_5 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" };
const _hoisted_6 = { class: "mt-3 text-center sm:mt-5" };
const _hoisted_7 = { class: "mt-2" };
const _hoisted_8 = { class: "text-sm text-gray-500" };
const _hoisted_9 = { class: "mt-5 sm:mt-6" };
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, } from '@headlessui/vue';
import { XIcon } from '@heroicons/vue/outline';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalWindow',
    props: {
        size: {
            type: String,
            default: 'lg',
            validator: (value) => [
                'sm',
                'md',
                'lg',
                'xl',
                '2xl',
                '3xl',
                '4xl',
                '5xl',
                '6xl',
                '7xl',
            ].includes(value),
        },
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const open = ref(true);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(TransitionRoot), {
                as: "template",
                show: open.value
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(Dialog), {
                        as: "div",
                        class: "relative z-10"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TransitionChild), {
                                as: "template",
                                enter: "ease-out duration-300",
                                "enter-from": "opacity-0",
                                "enter-to": "opacity-100",
                                leave: "ease-in duration-200",
                                "leave-from": "opacity-100",
                                "leave-to": "opacity-0"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_1
                                ]),
                                _: 1
                            }),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _hoisted_4,
                                    _createTextVNode(),
                                    _createVNode(_unref(TransitionChild), {
                                        as: "template",
                                        enter: "ease-out duration-300",
                                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                                        leave: "ease-in duration-200",
                                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(DialogPanel), {
                                                class: _normalizeClass(["relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-full", `max-w-${props.size}`])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_5, [
                                                            _renderSlot(_ctx.$slots, "icon")
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", null, [
                                                            _createVNode(_unref(XIcon), {
                                                                class: "absolute top-5 right-5 h-5 w-5 text-gray-400 hover:text-gray-900 cursor-pointer",
                                                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                                                            })
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("div", _hoisted_6, [
                                                            _createVNode(_unref(DialogTitle), {
                                                                as: "h3",
                                                                class: "text-lg leading-6 font-medium text-gray-900"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _renderSlot(_ctx.$slots, "title")
                                                                ]),
                                                                _: 3
                                                            }),
                                                            _createTextVNode(),
                                                            _createElementVNode("div", _hoisted_7, [
                                                                _createElementVNode("p", _hoisted_8, [
                                                                    _renderSlot(_ctx.$slots, "subtitle")
                                                                ])
                                                            ])
                                                        ]),
                                                        _createTextVNode(),
                                                        _renderSlot(_ctx.$slots, "main")
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_9, [
                                                        _renderSlot(_ctx.$slots, "footer")
                                                    ])
                                                ]),
                                                _: 3
                                            }, 8, ["class"])
                                        ]),
                                        _: 3
                                    })
                                ])
                            ])
                        ]),
                        _: 3
                    })
                ]),
                _: 3
            }, 8, ["show"]));
        };
    }
});
